import { Separator } from '../../../../../primitives/separator';
import { EditorPlain } from '../../../../editor/components/editor-plain';
import { LabelWithoutRef } from '../../../../label/label-without-ref';

import { Alignment } from '../controls/alignment';
import { Spacing } from '../controls/spacing';
import { Typography } from '../controls/typography';
import { Appearance } from './appearance';

import type { ButtonEditorContentProps } from './types';

export type { ButtonEditorStyleUpdates } from './types';

export function ButtonEditorContent({
  alignment,
  backgroundColor,
  buttonColor,
  fontFamily,
  fontSize,
  fontWeight,
  paddingBottom,
  paddingLeft,
  paddingRight,
  paddingTop,
  margin,
  size,
  styleVariant,
  text,
  textColor,
  url,
  width,
  onSizeChange,
  onStyleChange,
  onStyleVariantChange,
  onTextChange,
  onUrlChange,
  onWidthChange,
}: ButtonEditorContentProps) {
  return (
    <div className="grid gap-4">
      <div className="space-y-2">
        <p className="text-xs font-medium">Contenido</p>
        <div className="grid gap-y-1">
          <div>
            <LabelWithoutRef className="text-xs font-medium text-muted-foreground">
              Texto de botón
            </LabelWithoutRef>
            <EditorPlain
              counter={{ enable: true }}
              ext={{ mention: { items: ['variable'] } }}
              id="content-button"
              type="input"
              value={text}
              onChange={(value) => onTextChange(value)}
            />
          </div>
          <div>
            <LabelWithoutRef className="text-xs font-medium text-muted-foreground">
              URL de botón
            </LabelWithoutRef>
            <EditorPlain
              id="content-button-url"
              type="input"
              value={url}
              onChange={(value) => onUrlChange(value)}
            />
          </div>
        </div>
      </div>

      <Separator />

      <Appearance
        buttonColor={buttonColor}
        backgroundColor={backgroundColor}
        width={width}
        size={size}
        styleVariant={styleVariant}
        onStyleVariantChange={(styleVariant) => onStyleVariantChange(styleVariant)}
        onSizeChange={(size) => onSizeChange(size)}
        onWidthChange={(width) => onWidthChange(width)}
        onButtonBackgroundColor={(buttonBackgroundColor) =>
          onStyleChange({ buttonBackgroundColor })
        }
        onBackgroundColorChange={(backgroundColor) => onStyleChange({ backgroundColor })}
      />

      <Separator />

      <Typography
        fontFamily={fontFamily}
        fontSize={fontSize}
        fontWeight={fontWeight}
        isFontFamilyVisible
        isFontSizeVisible
        isFontWeightVisible
        isTextColorVisible
        textColor={textColor}
        onFontFamilyChange={(fontFamily) => onStyleChange({ fontFamily })}
        onFontSizeChange={(fontSize) => onStyleChange({ fontSize })}
        onFontWeightChange={(fontWeight) => onStyleChange({ fontWeight })}
        onTextColorChange={(buttonTextColor) => onStyleChange({ buttonTextColor })}
      />

      <Separator />

      <Alignment
        isHorizontalAlignmentVisible
        horizontalAlignment={alignment}
        onHorizontalAlignmentChange={(textAlign) => onStyleChange({ textAlign })}
      />

      <Separator />

      <Spacing
        margin={margin}
        onChangeMargin={(margin) => onStyleChange({ margin })}
        paddingTop={paddingTop}
        paddingBottom={paddingBottom}
        paddingLeft={paddingLeft}
        paddingRight={paddingRight}
        isPaddingVisible
        onChangePaddingBottom={(bottom) => onStyleChange({ padding: { bottom } })}
        onChangePaddingLeft={(left) => onStyleChange({ padding: { left } })}
        onChangePaddingRight={(right) => onStyleChange({ padding: { right } })}
        onChangePaddingTop={(top) => onStyleChange({ padding: { top } })}
      />
    </div>
  );
}
